module.exports = __webpack_public_path__ + "static/cyberstorm-9cdeff79abd0851693cb2fedc09be99c.jpg";